import React from 'react';
import "./Welcome.scss";

export default function Welcome() {
    function handleClick(){
        document.querySelector(".map").scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"})
    }
    return (
        <section className="welcome watch watch_header">
            <div className="wrapper">
                <div className="title main_header">הר המריבה</div>
                <div className="subtitle">עקדת יצחק, בית המקדש והמקום שבו עלה מוחמד השמיימה. הר הבית הפך ל"חבית הנפץ" של המזרח התיכון, שכבר התפוצצה פעם אחת לפני 20 שנה בדיוק. פרויקט מיוחד</div>
                <div className="arrow" onClick={() => handleClick()}></div>
            </div>
        </section>
    )
}
